













import TitleBar from '@/modules/core/components/TitleBar.vue';
import Tiles from '@/modules/core/components/Tiles.vue';
import CardWidget from '@/modules/core/components/CardWidget.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import DeviceEdit from '../components/DeviceEdit.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TitleBar,
    Tiles,
    CardWidget,
    CardComponent,
    DeviceEdit,
  },
})
export default class DeviceEditView extends Vue {
  public agency = {};

  public get titleStack(): string[] {
    return [
      'Admin',
      this.deviceId ? 'Edition de terminal' : 'Nouveau terminal',
    ];
  }

  public get deviceId(): string {
    return this.$router.currentRoute.params.id;
  }

  public goBack(): void {
    this.$router.go(-1);
  }

  public deviceEdited(): void {
    this.goBack();
  }
}
